<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="forgetPassword"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/forgetEmail-img.png"
                alt="login"
                class="forget-img"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h2 class="pass-header"><b>Check Your Email</b></h2>
                </div>

                <div>
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-mail"
                    icon-pack="feather"
                    v-model="verUsername.username"
                    class="w-full mt-6"
                  />
                  <div class="vx-row">
                    <vs-button
                      class="confirm-mail"
                      @click.stop="getgeneratekey"
                    >
                      {{ $t("Confirm") }}
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      email: "",
      username: "",

      message: "",
    };
  },
  computed: {
    ...mapState({
      verUsername: (state) => state.dashboard.username,
    }),
  },
  methods: {
    async getgeneratekey() {
      try {
        await this.$store.dispatch(
          "dashboard/setgeneratekey",
          this.verUsername.email
        );
        this.$router.push("/changePass");
      }catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
#forgetPassword {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
.forget-img {
  height: 300px;
}
.login-tabs-container {
  height: 300px;
}
.confirm-mail {
  margin-top: 35px;
  margin-left: 10rem;
}
.pass-header {
  margin-left: 15px;
  margin-top: 26px;
}
</style>
